import "./browser-hrm-left.css";
import "./index.less";



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-thumbnail/style/index.js